import { useState } from 'react';
import Icon from '../../../components/AppIcon';

import Select from '../../../components/ui/Select';

const SearchFilterBar = ({ 
  searchQuery, 
  onSearchChange, 
  sortBy, 
  onSortChange,
  filterBy,
  onFilterChange,
  onBulkMode 
}) => {
  const [showFilters, setShowFilters] = useState(false);

  const sortOptions = [
    { value: 'dueDate', label: 'Due Date' },
    { value: 'createdDate', label: 'Created Date' },
    { value: 'priority', label: 'Priority' },
    { value: 'custom', label: 'Custom Order' },
  ];

  const filterOptions = [
    { value: 'all', label: 'All Tasks' },
    { value: 'active', label: 'Active Only' },
    { value: 'completed', label: 'Completed Only' },
    { value: 'overdue', label: 'Overdue' },
    { value: 'today', label: 'Due Today' },
    { value: 'week', label: 'Due This Week' },
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-5 lg:p-6 mb-4 md:mb-5 lg:mb-6">
      {/* Search Bar */}
      <div className="flex items-center gap-2 md:gap-3 mb-3 md:mb-4">
        <div className="flex-1">
          <div className="relative">
            <Icon 
              name="Search" 
              size={18} 
              color="var(--color-muted-foreground)"
              className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
            />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e?.target?.value)}
              placeholder="Search tasks..."
              className="w-full pl-10 pr-4 py-2.5 md:py-3 rounded-lg border border-border bg-background text-sm md:text-base text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-all"
            />
          </div>
        </div>

        {/* Filter Toggle */}
        <button
          onClick={() => setShowFilters(!showFilters)}
          className={`w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center transition-all ${
            showFilters 
              ? 'bg-primary text-primary-foreground' 
              : 'bg-muted text-muted-foreground hover:bg-muted/80'
          }`}
          aria-label="Toggle filters"
        >
          <Icon name="SlidersHorizontal" size={20} color="currentColor" />
        </button>

        {/* Bulk Mode Toggle */}
        <button
          onClick={onBulkMode}
          className="w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center bg-muted text-muted-foreground hover:bg-muted/80 transition-all"
          aria-label="Bulk selection mode"
        >
          <Icon name="CheckSquare" size={20} color="currentColor" />
        </button>
      </div>
      {/* Filters Panel */}
      {showFilters && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 pt-3 md:pt-4 border-t border-border">
          <Select
            label="Sort By"
            options={sortOptions}
            value={sortBy}
            onChange={onSortChange}
          />

          <Select
            label="Filter"
            options={filterOptions}
            value={filterBy}
            onChange={onFilterChange}
          />
        </div>
      )}
    </div>
  );
};

export default SearchFilterBar;